import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css'; // Import the CSS file

const Dashboard = () => {
    const navigate = useNavigate();
    const [selectedOption, setSelectedOption] = useState('Padmaiog'); // State to track selected option
    const [projects, setProjects] = useState([
        {
          "name": "padmaiog",
          "url": "https://live.asktek.net/PadmaIOG_api/api/"
        },
        {
          "name": "TCMSWeb",
          "url": "http://192.168.1.15:1999/api/"
        }
      ]);

       useEffect(() => {
        sessionStorage.setItem('Project', "padmaiog");
        sessionStorage.setItem('Url', 'https://live.asktek.net/PadmaIOG_api/api/');
       }, [])
       
    const handleViewLogs = (type) => {
        console.log(`Selected Option: ${selectedOption}`); // Log selected option
        navigate(`/logs/${type}`);
    };

    const handleLogout = () => {
        // Clear authentication or any session data
        localStorage.removeItem('isAuthenticated');
        navigate('/'); // Redirect to the login page
    };

    const handleChange = (e) => {
        const selectedProject = projects.find((proj) => proj.name === e.target.value);
        setSelectedOption(selectedProject.name);
        sessionStorage.setItem('Project', selectedProject.name);
        sessionStorage.setItem('Url', selectedProject.url);
    };

    return (
        <div className="dashboard-container" style={{direction:'ltr',display:'grid', alignContent:'space-evenly'}} >
            {/* New card for select input */}
            <div className="dashboard-content">
                <label htmlFor="log-system" className="dashboard-description">Select Project:</label>
                <br/>
                <select
                style={{
                    marginTop: '10px',
                    border: 0,
                    width: '50%',
                    height: '30px',
                    borderRadius: '10px',
                   
                }}
                value={selectedOption}
                onChange={handleChange}
            >
                {projects.map((project) => (
                    <option key={project.name} value={project.name}>
                        {project.name}
                    </option>
                ))}
            </select>
            </div>

            {/* Original dashboard content */}
            <div className="dashboard-content">
                <h2 className="dashboard-title">Log Reviewer</h2>
                <p className="dashboard-description">
                    Access detailed logs for information and errors to monitor and troubleshoot system activities.
                </p>
                <div className="button-container">
                    <button onClick={() => handleViewLogs('info')} className="log-button info-button">
                        View Info Logs
                    </button>
                    <button onClick={() => handleViewLogs('error')} className="log-button error-button">
                        View Error Logs
                    </button>
                </div>
            </div>

            {/* Sticky Logout Button */}
            <button onClick={handleLogout} className="logout-button">
                Logout
            </button>
        </div>
    );
};

export default Dashboard;
